export const errorMessageOverrides: Record<string, string> = {
  'ERR-D018-0001': 'MKPでエラーが発生しました。しばらく待って改善されない場合はお問い合わせください。',
  'ERR-D018-0002': '取消可能期間を過ぎている等の理由により取消できません。',
  'ERR-D018-0006': 'MKPでエラーが発生しました。しばらく待って改善されない場合はお問い合わせください。',
  'ERR-D018-0008': 'MKPでアクセスが集中しています。しばらく待って再度実行してください。',
  'ERR-D018-0009': 'MKPでメンテナンス中です。しばらく待って再度実行してください。',
  'ERR-D018-0011': 'MKPでエラーが発生しました。しばらく待って改善されない場合はお問い合わせください。',
  'ERR-D999-0001': 'MKPでエラーが発生しました。しばらく待って改善されない場合はお問い合わせください。',
  'ERR-D999-0101': 'MKPでエラーが発生しました。しばらく待って改善されない場合はお問い合わせください。',
  'C999-0001': 'MKPでアクセスが集中しています。しばらく待って再度実行してください。',
  'C201-9001': 'MKPでエラーが発生しました。しばらく待って改善されない場合はお問い合わせください。',
  'C201-0021': 'MKPでエラーが発生しました。しばらく待って改善されない場合はお問い合わせください。',
  'C201-9002': 'MKPでエラーが発生しました。しばらく経ってからやり直してください。',
  'C201-9003': 'MKPの会員情報が見つからないため取消できません。',
  'C201-9004': 'MKPでエラーが発生しました。しばらく経ってからやり直してください。',
  'M999-0001': 'MKPでメンテナンス中です。しばらく待って再度実行してください。',
};
